/* Global imports. */
import React, {useRef} from "react";
import useIntersectionObserver from '@react-hook/intersection-observer'

interface Props {
  id: string;
  title: string;
  bottomMargin?: boolean;
}

const YouTubeEmbed = ({ id, title, bottomMargin=true }: Props) => {

  const containerRef = useRef()
  const lockRef = useRef(false)
  const { isIntersecting } = useIntersectionObserver(containerRef)
  if (isIntersecting) {
      lockRef.current = true
  }

  return (
    <div className={`relative w-full h-0 pb-[56.25%] max-w-full overflow-hidden aspect-w-16 aspect-h-9 ${bottomMargin && "mb-8"}`} ref={containerRef}>
      {lockRef.current && (
        <iframe
          className="absolute top-0 left-0 w-full h-full"
          title={title}
          src={`https://www.youtube.com/embed/${id}`}
          frameBorder="0"
          allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      )}
    </div>
  );
}

export default YouTubeEmbed;